"use client";

import { useLanguage } from "@/i18n/LanguageContext";

export default function MapSection() {
  const { t } = useLanguage();

  return (
    <section className="bg-[#fefce8] py-14 md:py-16">
      <div className="max-w-7xl mx-auto px-4 md:px-6">
        <div className="text-center mb-8 md:mb-10">
          <div className="inline-flex items-center gap-2 bg-[#047857] px-4 py-2 text-sm font-bold text-white mb-4 rounded-brand">
            <i className="ri-map-pin-line" />
            {t("map.badge")}
          </div>
          <h2 className="text-2xl md:text-[32px] font-black text-[#064e3b] leading-tight mb-3">
            {t("map.heading")}
          </h2>
          <p className="text-base md:text-lg text-[#374151] max-w-[600px] mx-auto leading-relaxed">
            {t("map.intro")}
          </p>
        </div>

        <div className="grid grid-cols-1 lg:grid-cols-3 gap-6 md:gap-8">
          {/* Map */}
          <div className="lg:col-span-2 rounded-xl overflow-hidden shadow-md border border-stone-200 h-[360px] md:h-[420px]">
            <iframe
              src="https://www.google.com/maps?q=848+Brickell+Ave,Miami,FL+33131&output=embed"
              width="100%"
              height="100%"
              style={{ border: 0 }}
              allowFullScreen
              loading="lazy"
              referrerPolicy="no-referrer-when-downgrade"
              title={t("map.iframeTitle") as string}
              className="w-full h-full"
            />
          </div>

          {/* Contact Card */}
          <div className="bg-white rounded-xl p-6 md:p-8 shadow-md border border-stone-200 flex flex-col justify-center">
            <h3 className="text-lg md:text-xl font-bold text-[#064e3b] mb-5">
              {t("map.contactHeading")}
            </h3>
            <div className="space-y-4">
              <div className="flex items-start gap-3">
                <div className="w-9 h-9 flex items-center justify-center rounded-lg bg-[#fefce8] text-[#047857] shrink-0">
                  <i className="ri-map-pin-fill text-lg" />
                </div>
                <div>
                  <p className="text-sm font-semibold text-[#374151]">{t("map.labelAddress")}</p>
                  <p className="text-sm text-[#6b7280] leading-relaxed">
                    848 Brickell Ave, PH-5<br />
                    Miami, FL 33131
                  </p>
                </div>
              </div>
              <div className="flex items-start gap-3">
                <div className="w-9 h-9 flex items-center justify-center rounded-lg bg-[#fefce8] text-[#047857] shrink-0">
                  <i className="ri-phone-fill text-lg" />
                </div>
                <div>
                  <p className="text-sm font-semibold text-[#374151]">{t("map.labelPhone")}</p>
                  <a
                    href="tel:+17863774452"
                    className="text-sm text-[#047857] hover:text-[#064e3b] font-medium transition-colors"
                  >
                    (786) 377-4452
                  </a>
                </div>
              </div>
              <div className="flex items-start gap-3">
                <div className="w-9 h-9 flex items-center justify-center rounded-lg bg-[#fefce8] text-[#047857] shrink-0">
                  <i className="ri-mail-fill text-lg" />
                </div>
                <div>
                  <p className="text-sm font-semibold text-[#374151]">{t("map.labelEmail")}</p>
                  <a
                    href="mailto:contact@impact-window-repair-miami.com"
                    className="text-sm text-[#047857] hover:text-[#064e3b] font-medium transition-colors"
                  >
                    contact@impact-window-repair-miami.com
                  </a>
                </div>
              </div>
              <div className="flex items-start gap-3">
                <div className="w-9 h-9 flex items-center justify-center rounded-lg bg-[#fefce8] text-[#047857] shrink-0">
                  <i className="ri-time-fill text-lg" />
                </div>
                <div>
                  <p className="text-sm font-semibold text-[#374151]">{t("map.labelHours")}</p>
                  <p className="text-sm text-[#6b7280]">
                    {t("map.hours")}
                  </p>
                </div>
              </div>
            </div>
          </div>
        </div>
      </div>
    </section>
  );
}